import { IPlan } from './plan';
import { UserPlan } from './user-plan';

export interface IUser {
  id?: string;
  _id?: string;
  role?: number;
  first_name?: string;
  last_name?: string;
  username?: string;
  photo?: string;
  last_login?: string;
  plan?: IPlan;
  use_demo_features?: boolean;
}

export class User {
  id: string;
  _id: string;
  role: number;
  first_name: string;
  last_name: string;
  username: string;
  photo: string;
  last_login: Date;
  baseRoleName: string = '';
  subRoleName: string = '';
  plan: UserPlan;
  use_demo_features?: boolean;

  constructor( data: IUser = {} ) {
    this.id = data.id;
    this._id = data._id;
    this.role = data.role;
    this.first_name = data.first_name;
    this.last_name = data.last_name;
    this.username = data.username;
    this.photo = data.photo;
    this.last_login = data.last_login ? new Date(data.last_login) : null;
    this.plan = new UserPlan(data.plan);
    this.use_demo_features = data.use_demo_features;
  }

  get fullname(): string {
    return `${this.first_name} ${this.last_name}`;
  }

  get currentPlanName(): string {
    return this.plan.currentPlan ? this.plan.currentPlan.name : '';
  }
}



// WEBPACK FOOTER //
// ./app/core/entities/user.ts